export const WEB_MODE = "WEB";
export const DESK_MODE = "DESK";